import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accordion-content" }

import { ref } from 'vue';
	import SlideTransition from '@/components/shared/SlideTransition.vue';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'Accordion',
  props: {
		isOpen: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			required: true
		},
		backgroundColor: {
			type: String,
			default: '#f2f3f5'
		},
		onExpand: {
			type: Function,
			default: () => {
				return;
			}
		},
		onClose: {
			type: Function,
			default: () => {
				return;
			}
		}
	},
  setup(__props) {

	const props = __props;

	const isOpen = ref(props.isOpen);

	const toggleAccordion = () => {
		isOpen.value = !isOpen.value;
		isOpen.value ? props.onExpand() : props.onClose();
	};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "accordion",
    style: _normalizeStyle({ backgroundColor: __props.backgroundColor })
  }, [
    _createElementVNode("div", {
      class: "accordion-header",
      onClick: toggleAccordion
    }, [
      _createElementVNode("h3", null, _toDisplayString(__props.label), 1),
      _createElementVNode("span", {
        class: _normalizeClass(isOpen.value ? 'arrow-up' : 'arrow-down')
      }, null, 2)
    ]),
    _createVNode(SlideTransition, { "is-visible": isOpen.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["is-visible"])
  ], 4))
}
}

})